import React, { FC } from 'react'
import { Text } from 'components/Text'
import { useTranslation } from 'react-i18next'

export const PredictiveReportDescription: FC = () => {
    const { t } = useTranslation()

    return (
        <Text>{t('confirmation_banner.PREDICTIVE_REPORT_TOOL.PREDICTIVE_REPORT_TOOL.click_on_map')}</Text>
    )
}

PredictiveReportDescription.displayName = 'PredictiveReportDescription'
